import { create } from "zustand";
import { devtools } from "zustand/middleware";
import { isProduction } from "../utils/constants.js";

export enum SessionMode {
    EXTENSION = "extension",
    CLOUD = "cloud",
}

export type UseSessionModeState = {
    mode: SessionMode;
    hasExtensionTakenOver: boolean;
};

export const useSessionMode = create<UseSessionModeState>()(
    devtools(
        () => ({
            mode: SessionMode.EXTENSION,
            hasExtensionTakenOver: false,
        }),
        { name: "useSessionMode", store: "useSessionMode", enabled: !isProduction },
    ),
);

export const setSessionMode = (mode: SessionMode) => {
    if (useSessionMode.getState().mode === mode) return;
    useSessionMode.setState({ mode }, undefined, "setSessionMode");
};

export const markExtensionTakenOver = () => {
    useSessionMode.setState({ hasExtensionTakenOver: true }, undefined, "markExtensionTakenOver");
};

export const releaseExtensionTakeover = () => {
    if (!useSessionMode.getState().hasExtensionTakenOver) return;
    useSessionMode.setState({ hasExtensionTakenOver: false }, undefined, "releaseExtensionTakeover");
};

export const isCloudSessionMode = (): boolean => useSessionMode.getState().mode === SessionMode.CLOUD;

export const useIsCloudSessionMode = (): boolean => useSessionMode((state) => state.mode === SessionMode.CLOUD);

export const useHasExtensionTakenOver = (): boolean => useSessionMode((state) => state.hasExtensionTakenOver);
